// modules/Stageplan.js
import React from 'react';
import $                from 'jquery';
import PlanDisplay      from './elements/PlanDisplay';
import PlanButton        from './elements/PlanButton';
import { browserHistory } from 'react-router';
import SiteDownloads    from '../common/SiteDownloads';
import PageLoading      from '../PageLoading';
import LandSearchBar	from './elements/LandSearchBar';
import BackButton       from '../common/BackButton';

import '../App.css';

import Messenger        from '../common/Messenger';
let messenger 			= new Messenger();

const sources = require('../config.json');

class Precinctplan extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.precinctplan_url = sources.precinctplan + '/' + this.props.params.precinct + "?ts=" + d.getTime();

		this.state = {
			data: {
				plan: {},
				downloads: [],
				elements: []
			},
			available: []
		};

		this.receivedStageplanData  = this.receivedStageplanData.bind(this);
		this.eachLotButton 			= this.eachLotButton.bind(this);
        this.onSearchClick      	= this.onSearchClick.bind(this);
	}

	componentDidMount() {
		$.ajax({url:this.precinctplan_url,dataType:'json'}).done(this.receivedStageplanData);
	}

    onSearchClick(frontage, land, url) {
        url = url + '?frontage='+frontage.start+'&frontage='+frontage.end+'&land='+land.start+'&land='+land.end;
        browserHistory.push(url);
    }

	receivedStageplanData(data, status, xhr) {

		if(typeof data.plan === 'undefined') data.plan = [];
		if(typeof data.downloads === 'undefined') data.downloads = [];
		if(typeof data.elements === 'undefined') data.elements = [];

		let newState = Object.assign(this.state, {
			data: data,
			available: data.elements
		});

		this.setState(newState);
		window.scrollTo(0,0);
       // document.getElementById('reloadScroll').scrollIntoView();
	}

	lotsAvailableText(lots) {
		if (lots > 0) {
			if(lots === 1) {
				return '1 lot'
			} else {
				return lots +' lots';
			}
		} else {
			return 'sold out';
		}

	}

    eachLotButton(element) {
		if (element.length !== 0) {
			return (
				<PlanButton key={element.id} id={element.id} messenger={messenger} buttonlink={element.link} buttonclass={element.class} lotCountTxt={this.lotsAvailableText(element.lot_count)}>{element.name}</PlanButton>
		)
		} else {
			return null;
		}
	}

	render() {
		if (typeof this.state.data.plan.plan_id !== "undefined") {
			return (
				<div className="App">
					<div id="reloadScroll"></div>
					<section className="section p-t-2">
						<div className="container">
							<div className="section__content tc">
								<h1 className="title f3 f4-md f-headline-lg m-b-4 m-b-4-md">Land For Sale</h1>
								<LandSearchBar onSearchClick={this.onSearchClick} onResetClick={null} search={this.props.location.query} divClass="filter release__filter js-accordion open"/>
							</div>
						</div>
					</section>
					<section className="section p-h-1 p-h-3-lg section-bg-white land-filter-section">
						<div className="container">
							<div className="cf top-land-filter-section  m-b-3-lg m-b-1">
								<div className="w-100">
									<BackButton link="/land-for-sale"/>
									<div className="cf"></div>
								</div>
								<div className="w-100 w-70-lg fr-lg">
								<PlanDisplay key={this.state.data.plan.plan_id}
											 messenger={messenger}
											 plan={this.state.data.plan}
											 elements={this.state.data.elements}
											 plantype="precinctplan"
								/>
								</div>
								<div className="w-100 w-30-lg fr-lg">
									<p className="m-b-0 p-a-1 brd-top small-blue-font tc tl-md">{this.state.data.plan.plan_name}</p>
									<ul className="">
										{this.state.available.map(this.eachLotButton)}
									</ul>
									<br />
									<br />
									<div className="btn__container">
										<a className="btn btn-primary w-100" href="/land-for-sale/search" target="_self">
											<span> View All Available Lots </span>
										</a>
									</div>
								</div>
							</div>
							<SiteDownloads  divClass="cf p-a-1 btm-land-filter-section m-b-3-lg m-b-1"/>
						</div>
					</section>
				</div>
			)
		} else {
			return (
				<PageLoading>Masterplan</PageLoading>
			)
		}
	}
}

export default Precinctplan;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/Precinctplan.js
 **/